import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import SectionTitle from 'components/section-title'
import useCoachBenchmarks from 'pages/pga-coach/benchmarks/use-coach-benchmarks'
import { COACH_BENCHMARKS_PATH } from './constants'
import { TopCoachesLink } from './top-coaches-definition'
import BenchmarkMetricRow from './benchmark-metric-row'
import useStyles from './styles'

// `title` adds a section header above the card (the Analytics page); it is part
// of the same early return, so it never shows without the card.
const PerformanceBenchmarks = ({ className, title, titleClassName }) => {
  const classes = useStyles()
  const { metrics, cohortSize, loading } = useCoachBenchmarks()

  if (loading || !metrics.length) {
    return null
  }

  return (
    <Box className={className}>
      {title ? (
        <SectionTitle size="large" className={titleClassName}>
          {title}
        </SectionTitle>
      ) : null}
      <Box className={classes.card}>
        <Box className={classes.cardHeader}>
          <Box className={classes.cardTitleBlock}>
            <SectionTitle className={classes.cardTitle}>
              How you're doing
            </SectionTitle>
            <Typography component="span" className={classes.cardSubtitle}>
              Review your performance compared to{' '}
              <TopCoachesLink cohortSize={cohortSize}>
                top lesson coaches
              </TopCoachesLink>{' '}
              on PGA Coach.
            </Typography>
          </Box>
          <Button
            component={RouterLink}
            to={COACH_BENCHMARKS_PATH}
            className={classes.cardAction}
          >
            View benchmarks
          </Button>
        </Box>

        <Box className={classes.metricList}>
          {metrics.map(metric => (
            <BenchmarkMetricRow
              key={metric.id}
              metric={metric}
              classes={classes}
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

PerformanceBenchmarks.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
}

export default PerformanceBenchmarks
